import PreloadState from "../../core/src/states/PreloadState";
import RealityCheckModel from "../../core/src/model/RealityCheckModel";
import App from "../../core/src/App";
import GameModel from "../../core/src/model/GameModel";
import Locale from "../../core/src/utils/Locale";
import GameLoader from "../../core/src/utils/GameLoader";
import ViewManager from "../../core/src/utils/ViewManager";
import { DefaultLayers } from "../../core/src/utils/Layers";
import PointerEvents from "../../core/src/const/PointerEvents";
import CommandManager from "../../core/src/commands/CommandManager";
import { Commands } from "../../core/src/commands/CommandEnum";
import LocalStorageVars from "../../core/src/const/LocalStorageVars";
import LocalData from "../../core/src/utils/LocalData";
import InstanceFactory from "../../core/src/factories/InstanceFactory";
import PreloadView from "../../core/src/views/PreloadView";
import UIController from "../../core/src/ui/UIController";
import { VendorCommandsEnum } from "../commands/VendorCommandsEnum";
import FullscreenUtils from "../../core/src/utils/FullscreenUtils";
import VendorWrapper from "../controllers/VendorWrapper";
import { Loader } from "pixi.js";
import VendorModel from "../model/VendorModel";
import FConnector from "../../src/server/FConnector";

export default class VendorPreloadState extends PreloadState {
    // startGame() {
    //     super.startGame();
    //     VWrapper.init();
    // }

    enter() {
        if (GameModel.gameConfig.hasJackpotsFeature) {
            setInterval(() => {
                CommandManager.execute(VendorCommandsEnum.UPDATE_JACKPOTS); //TODO lemmy think about setInterval

            }, 30000);
            CommandManager.execute(VendorCommandsEnum.UPDATE_JACKPOTS);
        };
        let lang: string = GameModel.lang.toLowerCase();
        if (lang == "en_st") {
            GameModel.lang = "en_sc";
        }
        super.enter();
    };

    startGame(): void {
        super.startGame();

        if (VendorModel.settings?.showPaytableAfterSplashScreen === "true") {
            CommandManager.execute(Commands.TOGGLE_PAYTABLE);
        }

        if (!GameModel.isReplay) {
            FConnector.gameReady();
        }
    }

    public bootComplete(loader: Loader) {
        FullscreenUtils.init(VendorWrapper.onResize);
        Locale.addSource(loader.resources.localization.data);
        this.preloadView = InstanceFactory.getClass("PreloadView") as PreloadView;
        // if (ViewManager.getDomLayer(DefaultLayers.Background)) {
        //     ViewManager.getDomLayer(DefaultLayers.Background).playDefault();
        // }

        GameLoader.loadAssets(
            GameLoader.config.mainResources,
            this.loadMusic.bind(this),
            this.preloadView.handleProgress.bind(this.preloadView)
        );
    }

    public preloadComplete() {
        CommandManager.execute(Commands.TOGGLE_LANDSCAPE_RESTRICT);
        App.assets.onResourcesLoaded();
        const preloadLayer = ViewManager.getLayer(DefaultLayers.Preloader);
        const scene = preloadLayer.setScene("start");
        // Preloader layer must be on top
        this.buildViews();
        scene.buttons.get("continue").on(PointerEvents.DOWN, this.onBtnClick);

        this.initSoundLoading();
        // RealityCheckModel.updateRealityCheckClock();

        // TODO destroy preloader from view manager
    }

    protected onBtnClick = () => {
        const preloadLayer = ViewManager.getLayer(DefaultLayers.Preloader);
        this.toggleInitialSounds();
        preloadLayer.clear();
        UIController.addTurboListener();
        this.startGame();
    }

    public toggleInitialSounds() {
        let hasFXStored = LocalData.getValue(LocalStorageVars.EFFECTS_ENABLED);
        let hasMusicStored = LocalData.getValue(LocalStorageVars.MUSIC_ENABLED);
        if (hasFXStored) {

            CommandManager.execute(
                Commands.TOGGLE_SOUND_FX,
                LocalData.getBooleanValue(LocalStorageVars.EFFECTS_ENABLED)
            );
        }
        if (hasMusicStored) {
            CommandManager.execute(
                Commands.TOGGLE_MUSIC,
                LocalData.getBooleanValue(LocalStorageVars.MUSIC_ENABLED)
            );
        }
    }
}
